import React, { Component } from "react";
import { Container, Row } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddAnnounceType from '../../components/Admin/addHebergement'
import AddAnnounceCar from '../../components/Admin/addCar'

import '../../style/css/pro/Admin.css'
import {
  faUserCircle,
  faPlus,
  faBullhorn,
  faHistory,
  faUsers,
  faPlane,
  faMapSigns,
  faBed,
  faBus,
  faCar,
  faPaperPlane,
  faChevronCDown,
  faChevronDown,
  faChevronRight
} from "@fortawesome/free-solid-svg-icons";
 import {
  NavLink, 
  } from "reactstrap";
  import { withRouter } from "react-router-dom";
  import { connect } from 'react-redux';
import { addAnn } from "../../slices/modalSlice";
import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';
import Calender from '../../components/common/calender';
import Switch from '@mui/material/Switch';
import DashCatego from "../../components/Admin/dashCatego";
import DashMenuItem from "../../components/Admin/dashMenuItem";
import DashAnnounce from "../../components/Admin/dashAnnounce";
import DiscussRow from "../../components/Admin/discussRow";
import MsgHeader from "../../components/Admin/msgHeader";
import Footer from "../../components/common/global_layout/footer";
import axios from "axios";
import {io} from "socket.io-client";
import  NewMessage from "../../components/Admin/newMsgModal";

class Messagerie extends Component {
  constructor(props) {
    super(props);
    this.state = {
      curentUser : this.props.currentUser,
      conversations : [],
      arrivalMessage : null,
      hostName : process.env.REACT_APP_SERVER_URL
    }
    this.socket = React.createRef(io("ws://localhost:8900"));
    
}

 user = this.props.currentUser


  getConversations = async () => {
  try {
    const HOST_NAME = this.state.hostName
    const res = await axios.get(`/api/conversations/user/`+this.user._id)
    console.log(res.data);
    this.setState({conversations : res.data})
  
  } catch (error) {
    console.log(error);
  }
}
componentDidMount() {
  
  
  this.socket.current = io("ws://localhost:8900")
  this.socket.current.on("getMessage", data =>{
    this.setState({arrivalMessage : {
      sender : data.senderId,
      text : data.text,
      //createdAt : Date.now()
    }})
  })


  this.socket.current.emit("addUser", this.user._id)
  this.socket.current.on("getUsers", users =>{
  
  })
  this.getConversations()
}


  render() {
 
    
    return (
    <>

    <NewMessage currentUser={this.user} />
  

    <div className="container pt-4 pb-5 mb-5">
       <div className="col-12">
         <DashCatego name="Messagerie" />
         <MsgHeader currentUser = {this.user} />
         <div className="conversations mt-4">
             <div className="conv__header d-flex justify-content-between align-items-center px-1">
                 <h2 className="bienvenu__txt">Conversations (tout)</h2>
                 <h6 className="msgr__txt">Actions</h6>
             </div>
             <hr />
             <div className="conv__list">
               {this.state.conversations.map((conv) =>(
                 <DiscussRow  conversation={conv} currentUser={this.user}/>
               ))}
                 
             </div>
          
             <NavLink>
             <div className="conv__selectAll    d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                   <input type="checkbox" className="conv__check toutCheck" name="all" id="all" />
                   <span className="conv__profile">Tout</span>
                </div>
                <div className="conv__actions d-flex align-items-center">
                      <span className="conv__profile mt-2">Séléction</span>
                      <img src="/imgs/dash/return.svg" className="mt-2 ml-4" id="return__msg" alt="" />
                      <img src="/imgs/dash/opened.svg" className="msg__actions ml-3 mt-1" alt="" />
                      <img src="/imgs/dash/times.svg" className="msg__actions ml-3" alt="" />
                      <img src="/imgs/dash/archive_do.svg" className="msg__actions ml-3 mt-1" alt="" />
                </div>
             </div>
             </NavLink>
       
         </div>
       </div> 
      
    </div>


    <Footer />




    </>

    );
  }
}


function mapStateToProps(state) {
  return {
    /*
    isOpenAddanc: state.counterApp.isOpenAddanc,
    */
  }
}

//connect function INJECTS dispatch function as a prop!!
export default withRouter(connect(mapStateToProps)(Messagerie));